import axios from "axios";
import { jwtDecode } from "jwt-decode";

import { EXTERNAL_LOGIN_URL } from "../consts";

import { getIsIpDomain } from "./_getIsIpDomain";

import { LexSsoAuthTokenPayload } from "../models";
import { ssoUserManager } from "./sso";

const getStoredToken = () => localStorage.getItem("token") || null;

const remote = true;

const apiDomain = remote
  ? "https://plataforma.lex.com.br"
  : "http://localhost:3001";

export const apiInstancePublic = axios.create({
  baseURL: `${apiDomain}/api/lex/produto/v1/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const apiInstance = axios.create({
  baseURL: `${apiDomain}/api/lex/produto/v1/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.request.use(
  (config) => {
    const token = getStoredToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      const { status, data } = error.response;

      if (data?.simultaneousError) {
        switch (data.code) {
          case "GLOBAL_LIMIT_EXCEEDED":
            window.location.href = "/limite-acessos";
            return;

          case "DEVICE_LIMIT_EXCEEDED":
            window.location.href = "/limite-acessos-usuario";
            return;
        }
      }

      const isIpDomain = getIsIpDomain();

      if (status === 401) {
        const token = getStoredToken();

        localStorage.removeItem("token");

        try {
          if (token && isIpDomain) {
            const decoded: LexSsoAuthTokenPayload = jwtDecode(token);

            if (decoded?.type === "sso_user") {
              if (decoded.provider === "AASP")
                await ssoUserManager.signinRedirect();
              else {
                window.location.href = decoded.redirectUrl || "/login";
              }
              return;
            }
          }
        } catch (err) {
          console.error("Erro ao validar token SSO", err);
        }

        if (!isIpDomain) {
          window.location.href = EXTERNAL_LOGIN_URL;
        } else if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }

      if (status >= 500) {
        console.error("Erro no servidor:", data);
      }
    } else if (error.code === "ECONNABORTED") {
      console.error("Tempo limite da requisição excedido.");
    }

    return Promise.reject(error);
  },
);
